import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-51-sudhir-mehta-guest.webp";
import ThumbImg from "../../assets/images/conversations/051.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: sm-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .sm-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .sm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .sm-hero { padding-top: 60px; padding-bottom: 60px; }
  .sm-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .sm-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .sm-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sm-hero__title.sm-visible { opacity: 1; transform: translateY(0); }
  .sm-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .sm-hero__spotify.sm-visible { opacity: 1; transform: translateY(0); }
  .sm-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .sm-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .sm-hero__right.sm-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .sm-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .sm-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .sm-yt-thumb:hover img { opacity: 0.85; }
  .sm-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .sm-yt-thumb__play img { width: 40px; height: 44px; }
  .sm-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .sm-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .sm-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sm-body.sm-visible { opacity: 1; transform: translateY(0); }
  .sm-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .sm-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .sm-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sm-guest.sm-visible { opacity: 1; transform: translateY(0); }
  .sm-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .sm-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .sm-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .sm-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .sm-inner { padding-left: 32px; padding-right: 32px; }
    .sm-hero { padding-top: 32px; padding-bottom: 48px; }
    .sm-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .sm-hero__title { font-size: 24px; }
    .sm-hero__left { gap: 16px; }
    .sm-guest__title { font-size: 24px; margin-bottom: 24px; }
    .sm-guest__photo-bg { width: 260px; height: 300px; }
    .sm-guest__name { font-size: 24px; margin-top: 18px; }
    .sm-body__para { font-size: 14px; margin-bottom: 12px; }
    .sm-body { padding-bottom: 48px; }
    .sm-guest { padding-bottom: 48px; }
    .sm-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .sm-inner { padding-left: 16px; padding-right: 16px; }
    .sm-hero { padding-top: 51px; padding-bottom: 30px; }
    .sm-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .sm-hero__left { gap: 30px; }
    .sm-hero__title { font-size: 30px; }
    .sm-body__para { font-size: 16px; margin-bottom: 10px; }
    .sm-guest__title { font-size: 30px; margin-bottom: 20px; }
    .sm-guest__photo-bg { width: 100%; height: 386px; }
    .sm-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .sm-body { padding-bottom: 30px; }
    .sm-guest { padding-bottom: 30px; }
    .sm-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sm-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "bLcp7V8Ebz4";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="sm-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 51 Sudhir Mehta"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="sm-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 51 Sudhir Mehta thumbnail" />
      <div className="sm-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="sm-hero">
      <div className="sm-inner">
        <div className="sm-hero__grid">
          <div className="sm-hero__left">
            <h1 ref={titleRef} className="sm-hero__title">
              EP 51 | Revolutionizing India's Buses: A Startup's Electric Impact | Sudhir Mehta | EKA &amp; Pinnacle Industries
            </h1>
            <div ref={spotifyRef} className="sm-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/6D1SPxztO3MdcK2zAKhqSC?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 51 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="sm-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sm-body">
      <div className="sm-inner">
        <p className="sm-body__para">
          India has 326 million registered vehicles on the road in 2024. Seventy-five percent of these are two-wheelers, including scooters and motorcycles, down from 80% just four years ago. Approximately 12% of these are trucks and buses, with the vast majority being trucks, as only 2% of registered vehicles in India are buses. The fastest way to clean the air in Indian cities is to convert public transportation, including intra-city and intercity buses, to electric. The government has made significant progress in this area over the last four years, converting over 5,000 buses a year in Indian cities to electric. Initially, Chinese buses played a key role in this transition, but over the last four years, Indian entrepreneurs have invested boldly to implement new technology made in India for electrification and clean mobility in Indian cities. Today, we are speaking with one such company, an Indian gem: Eka Mobility. We welcome to the programme Sudhir Chairman, founder and CEO of EKA Pinnacle Industries.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="sm-guest">
      <div className="sm-inner">
        <h2 className="sm-guest__title">Our Guest</h2>
        <div>
          <div className="sm-guest__photo-bg">
            <img src={GuestImg} alt="Sudhir Mehta" />
          </div>
          <p className="sm-guest__name">Sudhir MEHTA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep51SudhirMehta() {
  return (
    <>
      <style>{CSS}</style>
      <div className="sm-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}